import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { theme } from '@primer/react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Note mdxType="Note">
      <p>{`See `}<a parentName="p" {...{
          "href": "/theming"
        }}>{`Theming`}</a>{` to learn how theming works in Primer React.`}</p>
    </Note>
    <p>{`Colors in this theme object are imported from `}<a parentName="p" {...{
        "href": "https://primer.style/primitives/colors"
      }}>{`Primer Primitives`}</a>{`.`}</p>
    <pre><code className="language-json">{JSON.stringify(theme, null, 2)}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      